import EditArticleContainer from "@containers/dashboard/articles/edit";
import { ArticleDefaultValue } from "@containers/dashboard/articles/edit/settings";
import DashboardLayout from "@layouts/dashboard";
import RoutesInstance from "@routes/instances";
import { useQuery } from "@tanstack/react-query";
import Common from "@utilities/common";
import { useEffect } from "react";
import {
    useLocation,
    useNavigate,
    useParams,
    useSearchParams,
} from "react-router-dom";

const EditArticle = () => {
    const params = useParams();

    const [URLSearchParams] = useSearchParams();

    const { pathname } = useLocation();

    const Navigate = useNavigate();

    const { data, isLoading, refetch } = useQuery(
        ["getArticle"],
        () =>
            Common.api.articles
                .GetSingle({
                    id: params.id || "",
                })
                .then((res) => res.data),
        {
            enabled: true,
            retry: false,
            onError: () => {
                Navigate(RoutesInstance.articles);
            },
            onSuccess: () => {
                URLSearchParams.set("refetch", "");

                Navigate(
                    {
                        pathname,
                        search: "?" + URLSearchParams.toString(),
                    },
                    {
                        replace: true,
                    },
                );
            },
        },
    );

    useEffect(() => {
        if (URLSearchParams.get("refetch") === "true") {
            refetch();
        }
    }, [URLSearchParams]);

    return (
        <DashboardLayout title="ویرایش مقاله">
            <EditArticleContainer
                data={data?.result || ArticleDefaultValue}
                loading={isLoading}
            />
        </DashboardLayout>
    );
};

export default EditArticle;
